export default {
  data() {
    return {
      inforUser: JSON.parse(localStorage.getItem("auth.currentUser")),
      inforMerchant: JSON.parse(localStorage.getItem("auth.currentMerchant"))
    }
  },

  methods: {
    reqCheckinOrder(data) {
      return {
        orderNo: (data.orderNo === '') ? null : data.orderNo,
        locationId: data.locationId,
        currency: "VND",
        note: data.furtherInstructions[0].params.note,
        furtherInstructions: [
          {
            key: "CHECK_IN",
            cat: "INVENTORY_OPERATION",
            note: "",
            params: {
              employeeId: this.inforUser.userId,
              employeeName: this.inforUser.name,
              employeePhone: this.inforUser.phone,
              reason: data.furtherInstructions[0].params.reason,
              note: data.furtherInstructions[0].params.note,
              referenceCode: "mã tham chiếu",
              toInventoryId: data.inventoryId,
              toInventoryName: data.inventoryName
            },
          },
          {
            key: "FOR_PRODUCT_BATCH",
            cat: "FOR_PRODUCT_BATCH",
            note: "",
            params: {}
          }
        ],
        lineItem: data.lineItem.map(e => {
          const prices = [
            {
              amount: this.multiplicationThousand(
                this.checkNumReplaceComma(e.prices.exportPrice)
              ),
              priceTypeCode: "PRICE_EXPORT",
              currency: "VND",
            },
            {
              amount: this.multiplicationThousand(
                this.checkNumReplaceComma(e.prices.importPrice)
              ),
              priceTypeCode: "PRICE_IMPORT",
              currency: "VND",
            },
          ];
          if (e.useProductBatch) {
            return e.expirationSelect.map(expiration => {

              const productBatch = {
                "batchCode": expiration.batchCode,
                "quantity": expiration.quantityChoose,
                "manufactureDate": expiration.manufactureDate,
                "expirationDate":  expiration.expirationDate,
                "type": "NSH_ITEM_SALE" 
              }

              return {
                lineItemId: e.lineItemId,
                unit: e.unit.name,
                quantity: this.checkNumReplaceComma(expiration.quantityChoose),
                unitPrice: this.multiplicationThousand(e.unitPrice),
                amount: this.multiplicationThousand(
                  this.checkNumReplaceComma(e.amount)
                ),
                totalAmount: this.multiplicationThousand(
                  this.checkNumReplaceComma(e.amount)
                ),
                lineItemOtherInfo: {
                  productBatch: JSON.stringify(productBatch)
                },
                itemInstance: {
                  itemId: e.lineItemId,
                  itemVariationId: e.variationId,
                  category: e.category,
                  name: e.itemInstanceName,
                  metaNonSearchable: {},
                  metaSignature: "",
                  taxes: [],
                  discounts: [],
                  warranty: {},
                  expiry: {},
                  unit: e.unit,
                  prices: prices,
                  note: "",
                  moreInformation: {
                    name: e.variationName,
                    sku: e.sku,
                    upc: e.upc,
                    options: e.options,
                    version: e.version,
                    heightInCentimeter: 0,
                    lengthInCentimeter: 0,
                    weightInGram: 0,
                    widthInCentimeter: 0
                  },
                }
              }
            })
          } else {
            return {
              lineItemId: e.lineItemId,
              unit: e.unit.name,
              quantity: this.checkNumReplaceComma(e.quantity),
              unitPrice: this.multiplicationThousand(e.unitPrice),
              amount: this.multiplicationThousand(
                this.checkNumReplaceComma(e.amount)
              ),
              totalAmount: this.multiplicationThousand(
                this.checkNumReplaceComma(e.amount)
              ),
              lineItemOtherInfo: {
                updatedAt: "2100-04-06T03:32:10.812Z",
                inventoryId: e.lineItemOtherInfo.inventoryId,
                seriesNo: JSON.stringify(e.lineItemOtherInfo.seriesNo)
              },
              itemInstance: {
                itemId: e.lineItemId,
                itemVariationId: e.variationId,
                category: e.category,
                name: e.itemInstanceName,
                metaNonSearchable: {},
                metaSignature: "",
                taxes: [],
                discounts: [],
                warranty: {},
                expiry: {},
                unit: e.unit,
                prices: prices,
                note: "",
                moreInformation: {
                  name: e.variationName,
                  sku: e.sku,
                  upc: e.upc,
                  options: e.options,
                  version: e.version,
                  heightInCentimeter: 0,
                  lengthInCentimeter: 0,
                  weightInGram: 0,
                  widthInCentimeter: 0
                },
              }
            }
          }
        }).flat(),
        partyA: {
          title: "BUYER",
          displayName: this.inforMerchant.name,
          address: this.inforMerchant.address,
          phoneNo: this.inforMerchant.phoneNo,
          role: "MERCHANT",
          source: "",
          otherInfo: {}
        },
        partyB: {
          title: "SUPPLIER",
          displayName: data.partyB.name,
          address: data.partyB.address,
          phoneNo: data.partyB.phoneNo,
          role: "SUPPLIER",
          source: "CORE",
          resName: "PARTNER",
          resCat: "PARTNER",
          resId: data.partyB.id,
          otherInfo: {
            email: data.partyB.email,
          }
        },
      }
    },
  }
}